import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './_Well.scss';

/**
 * A Well component for framing and centering text.
 * Use the well as a simple effect on an element to give it an inset effect.
 * @param props
 * @returns {XML}
 * @constructor
 */
const Well = ({ className, children, style, ...restProps }) => {
  return (
    <div className={classNames('Well', className)} style={style} {...restProps}>
      {children}
    </div>
  );
};

Well.propTypes = {
  /**
   * Class to add to the top level block
   */
  className: PropTypes.string,
  /**
   * Custom style
   */
  style: PropTypes.object,
  /**
   * The elements which will be inside the well (header, main and footer).
   */
  children: PropTypes.node.isRequired
};

export default Well;
